export default {
  SIGN_IN: 'signIn',
  SIGN_UP: 'signUp',
  SIGN_OUT: 'signOut',
  SIGN_IN_FAILURE: 'signIn_failure',
  CONFIGURED: 'configured'
};
